import styled from "styled-components"
import Breakpoints from "../breakpoints"
import { desktopTextStyles, FontFamilySmartScreen } from "../typography.styles"

export const Container = styled.div`
  grid-column: 1 / -1;
  /* margin: 48px 0; */
  color: var(--body-text-grey);
  ${desktopTextStyles.BodyText18};

  & > h3 {
    margin-top: 32px;
    ${FontFamilySmartScreen}
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 128%;
    /* identical to box height, or 28px */
    color: ${(props) => props.titleColor || "var(--body-text-grey)"};

    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  & > p {
    margin: 16px 0 16px 0;
  }

  & > ul > li {
    list-style-type: disc;
    list-style-position: inside;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    margin-top: 16px;
  }

  @media (min-width: ${Breakpoints.md}) {
    display: none;
  }
`
